import { Button, type TPlacement, TooltipDesktop } from '@cian/ui-kit';

import { type FC, type SyntheticEvent, useCallback } from 'react';

import { HideIcon } from '@/packages/shared-ui/components/HideIcon';

import { useHideOffer } from '../../../hooks/card/useHideOffer';
import { ControlWrapper } from '../components/Controls';

type HideContainerProps = {
  tooltipPlacement?: TPlacement;
};

export const HideContainer: FC<HideContainerProps> = props => {
  const { tooltipPlacement = 'left' } = props;
  const hideOffer = useHideOffer();

  const handleHideOffer = useCallback(
    (e: SyntheticEvent) => {
      e.stopPropagation();
      hideOffer();
    },
    [hideOffer],
  );

  return (
    <ControlWrapper>
      <TooltipDesktop placement={tooltipPlacement} theme="black" title="Скрыть">
        <Button
          beforeIcon={<HideIcon />}
          data-testid="HideOfferControl"
          size="XS"
          theme="stroke_secondary"
          onClick={handleHideOffer}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
};
